import { render, staticRenderFns } from "./EditKitLevel.vue?vue&type=template&id=52026a8d&scoped=true&"
import script from "./EditKitLevel.vue?vue&type=script&lang=ts&"
export * from "./EditKitLevel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52026a8d",
  null
  
)

export default component.exports